module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "insetGraph",
    attrs: {
      "id": "activity-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-paper', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-content-block', [_c('service-tracking-types', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "margin-top": "4px",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "activity",
      "current-service": "FITBIT"
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('activity-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "bmr": _vm.$store.state.user.stats.bmr
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px",
      "padding-top": "8px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.startTime))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing"
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        }
      }, [_c('div', [_c('mu-row', [_c('mu-col', [_c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.startTime, item.duration))
        }
      })]), _vm._v(" "), _c('mu-col', {
        staticClass: "reading"
      }, [_vm._v("\n                      " + _vm._s(item.activityName) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
        staticClass: "reading",
        staticStyle: {
          "margin-bottom": "12px"
        }
      }, [_vm._v(_vm._s(_vm.duration(item.duration)))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block",
          "margin-right": "8px"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "color": "#3d8517",
          "value": "directions_walk"
        }
      }), _vm._v("\n                    " + _vm._s(_vm.numberFormat(item.calories)) + " "), _c('span', {
        staticClass: "lite"
      }, [_vm._v("kcal")])], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "color": "red",
          "value": "favorite"
        }
      }), _vm._v("\n                    " + _vm._s(item.averageHeartRate) + " "), _c('span', {
        staticClass: "lite"
      }, [_vm._v("avg bpm")])], 1), _vm._v(" "), (item.heartRateZones && item.calories > 0) ? _c('div', {
        staticStyle: {
          "margin-top": "8px"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "value": "access_time"
        }
      }), _vm._v(" " + _vm._s(_vm.fatBurnPercentageMins(item.heartRateZones)) + " of fat burn\n                    "), _c('div', {
        staticClass: "heartRateZone",
        staticStyle: {
          "width": "250px"
        }
      }, [_c('div', {
        staticClass: "fillBar",
        style: ({
          width: _vm.fatBurnPercentage(item.heartRateZones)
        })
      })])], 1) : _vm._e()], 1)])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading === true) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading === false) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb4b48b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/ActivityFitbit.vue
// module id = 3802
// module chunks = 1